export const SCOPE = 'metricsChartContainer';
export const RESET = `${SCOPE}/RESET`;
export const SELECTED_METRIC_CHART = `${SCOPE}/SELECTED_METRIC_CHART`;
export const GET_CHART_DATA = `${SCOPE}/GET_CHART_DATA`;
export const GET_CHART_DATA_FAILED = `${SCOPE}/GET_CHART_DATA_FAILED`;
export const SAVE_CHART_DATA = `${SCOPE}/SAVE_CHART_DATA`;
export const CHANGE_METRICS_ORDER = `${SCOPE}/CHANGE_METRICS_ORDER`;
export const SAVE_CHART_QUERY = `${SCOPE}/SAVE_CHART_QUERY`;
export const SHOW_AUDIENCE_DATA = `${SCOPE}/SHOW_AUDIENCE_DATA`;
export const SHOW_ALL_DATA = `${SCOPE}/SHOW_ALL_DATA`;

export const INIT = `${SCOPE}/INIT`;
export const SET_BATCHES = `${SCOPE}/SET_BATCHES`;
export const SET_METRICS = `${SCOPE}/SET_METRICS`;
export const SET_LOADING_STATE = `${SCOPE}/SET_LOADING_STATE`;
export const ADD_SUMMARY_METRIC = `${SCOPE}/ADD_SUMMARY_METRIC`;
export const SET_LIVE_DATE = `${SCOPE}/SET_LIVE_DATE`